import { Navigate } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useAuth } from '../context/AuthContext';

// Gates the School Hub on the right to OPEN other schools, which is a
// different right from managing them:
//
//   canSwitchSchools  — an "All schools" user, or a super administrator
//                       of the main school. These people may step into
//                       any school and come back.
//   canManageSchools  — may create/rename/deactivate schools. Not
//                       required here: opening a school is not
//                       administering the list of schools.
//
// A super administrator of another school has neither, so the hub is
// invisible to them — they only ever see their own school.
//
// Resolved from /api/schools/current (via AuthContext) rather than from
// the token, so moving someone to another school closes the hub off on
// their next page load. The API enforces it independently on every
// request; this only hides the screen.
export default function SchoolHubGuard({ children }) {
  const { user, multiSchoolLoading, multiSchoolEnabled, canSwitchSchools } = useAuth();

  if (!user) return <Navigate to="/login" replace />;
  if (multiSchoolLoading) {
    return (
      <Box sx={{ p: 6, textAlign: 'center' }}>
        <CircularProgress />
      </Box>
    );
  }
  if (!multiSchoolEnabled) return <Navigate to="/dashboard" replace />;
  if (!canSwitchSchools) return <Navigate to="/dashboard" replace />;

  return children;
}
